<div class="download-up">
    <div class="download-up__wrap">
        <h2 class="download-up__title">завантажуйте Новий застосунок Укрпошти</h2>

        <div class="download-up__txt">
            <p>Знаходьте відділення та прокладайте маршрут на карті</p>
        </div>

        <div class="download-up__controls">
            <div class="download-up__controls-mob">
                <a href="https://play.google.com/store/apps/details?id=ua.ukrposhta.ukrposhta" target="_blank" class="download-up__controls-link">
                    <img src="./assets/img/mobile-store/google-play.png" width="129" alt="Google Play" class="download-up__controls-icon">
                </a>

                <a href="https://apps.apple.com/ua/app/%D1%83%D0%BA%D1%80%D0%BF%D0%BE%D1%88%D1%82%D0%B0-2-0/id6714448576?l=uk" target="_blank" class="download-up__controls-link">
                    <img src="./assets/img/mobile-store/app-store.png" width="129" alt="App Store" class="download-up__controls-icon">
                </a>
            </div>

            <div class="download-up__controls-desktop">
                <div class="download-up__qr">
                    <a href="https://play.google.com/store/apps/details?id=ua.ukrposhta.ukrposhta" target="_blank" class="download-up__qr-wrap">
                        <img src="./assets/img/download-up/download-up-gp.svg" alt="Google Play" class="download-up__qr-img">
                    </a>

                    <span class="download-up__qr-txt">Google Play</span>
                </div>

                <div class="download-up__qr">
                    <a href="https://apps.apple.com/ua/app/%D1%83%D0%BA%D1%80%D0%BF%D0%BE%D1%88%D1%82%D0%B0-2-0/id6714448576?l=uk" target="_blank" class="download-up__qr-wrap">
                        <img src="./assets/img/download-up/download-up-as.svg" alt="App Store" class="download-up__qr-img">
                    </a>

                    <span class="download-up__qr-txt">App Store</span>
                </div>
            </div>
        </div>
    </div>
</div>
